import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { ICompositeFilterClause } from '~src/spacesPlatform/models/IFilterClause';

import { Request } from '../../../../httpClient/serverApi/requests/Request';

export interface IGetServerUserMaxSiteRoleCountsParams {
  filter?: ICompositeFilterClause;
}

export interface ISiteRoleCounts {
  label: string;
  count: number;
}

export interface IGetServerUserMaxSiteRoleCountsResult extends IResult {
  totalUserCount: number;
  siteRoleCounts: ISiteRoleCounts[];
}

export class GetServerUserMaxSiteRoleCountsRequest extends Request<IGetServerUserMaxSiteRoleCountsParams, IGetServerUserMaxSiteRoleCountsResult> {
  constructor(params: IGetServerUserMaxSiteRoleCountsParams = {}) {
    super('getServerUserMaxSiteRoleCounts', params);
  }
}